import { loadScript } from "../util/LoadScript";

interface EmbedHash {
  [id: string]: boolean;
}

export interface Executor {
  /** Executes a recaptcha request returning a promise which contains the ReCaptcha token. */
  (options: ExecutorOptions): Promise<string>;
}

export interface ExecutorOptions {
  action: string;
}

declare global {
  interface Window {
    // Add the $axios property on every vue instance.
    grecaptcha: {
      execute(siteKey: string, options: ExecutorOptions): Promise<string>;
      ready(cb: () => void): void;
    }
  }
}

const embedded: EmbedHash = {};
const readyHash: EmbedHash = {};
const has = (obj: unknown, key: string) => Object.prototype.hasOwnProperty.call(obj, key);

/**
 * Promisify the ready method for recaptcha.
 */
function ready(): Promise<void> {
  return new Promise((resolve, reject) => {
    window.grecaptcha.ready(() => resolve());
  });
}

/**
 * Embeds the recaptcha api into the site if it has not been already.
 * @param siteKey The site key provided by the recaptcha admin dashboard
 */
export async function embed(siteKey: string): Promise<Executor> {
  if (!has(embedded, siteKey)) {
    // Wait for the recaptcha service to be loaded.
    embedded[siteKey] = true;
    await loadScript(
      `https://www.google.com/recaptcha/api.js?render=${siteKey}`
    );
  }

  if (!has(readyHash, siteKey)) {
    await ready();
    readyHash[siteKey] = true;
  }
  console.log("Recaptcha ready");
  
  /**
   * The function to call actions on.
   */
  return function(options: ExecutorOptions) {
    return window.grecaptcha.execute(siteKey, options);
  };
}
